<template>
  <div class="nav-left">
    
    <div class="nav-list" v-for="(item,i) in navDataList" :key='i'>
      <h3 @click="pnavClick(item.navPath)" :class="href.indexOf(item.navPath) != -1 ?'on':''">{{item.name}}</h3>
      <ul class="nav-ul" v-if="item.children.length>0">
        <li v-for="(ite,j) in item.children" :key="j" @click="cnavClick(ite.navPath)" :class="href.indexOf(ite.navPath) != -1 ?'on':''">
          <img :src="'/static/user/icon'+(j+1) + (href.indexOf(ite.navPath) != -1 ?'_on':'') +'.png'" :alt="ite.name">
          {{ite.name}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "UserNav",
  data() {
    return {
      userInfo: store.state.UserInfo ? store.state.UserInfo : JSON.parse(localStorage.getItem("UserInfo")),
      currIndex:[0,0],
      href:location.href,
      navDataList: [
        {
          name: "个人主页",
          children: [
            {
              name: "我的发布",
              navPath: "/user/personal/"+ JSON.parse(localStorage.getItem("UserInfo")).id,
            },
            {
              name: "我的关注",
              navPath: "/user/personalfollow",
            },
            {
              name: "我的粉丝",
              navPath: "/user/personalfans",
            },
            {
              name: "我的收藏",
              navPath: "/user/personalCollect",
            },
            {
              name: "我的赞",
              navPath: "/user/personallike",
            },
            {
              name: "消息",
              navPath: "/user/personalinformation",
            },
            {
              name: "浏览记录",
              navPath: "/user/personalvisit",
            },
          ],
        },
        {
          name: "资料修改",
          navPath: "/user/personalsetting",
          children: [],
        },
        {
          name: "帮助中心",
          navPath: "/user/personalhelp",
          children: [],
        },
      ],
    };
  },
  methods: {
    pnavClick(navPath){
      this.$router.push(navPath);
    },
    cnavClick(navPath){
      this.$router.push(navPath);
    }
  },
  created(){
    // console.log(this.userInfo);
  }
};
</script>

<style scoped lang="scss">
.nav-left {
  width: 250px;
  padding: 10px;
  background: #fff;
  .nav-list {
    h3{
      padding-left: 18px;
      height: 56px;
      font-size: 20px;
      color: #121212;
      font-weight: 600;
      line-height: 56px;
      cursor: pointer;
      &.on {
        color: #317DFF;
        background: #f5f5f5;
      }
    }
  }
  .nav-ul {
    li {
      height: 48px;
      line-height: 48px;
      font-size: 18px;
      padding-left: 30px;
      cursor: pointer;
      img {
        margin-right: 10px;
        vertical-align: middle;
      }
      &.on {
        color: #317DFF;
        background: #f5f5f5;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UserLeftNav.vue